import React from "react";
import {LineChart, Line, XAxis, YAxis, Tooltip} from 'recharts';
import {DashboardMainGet} from "../models/dashboardMain";


export class Dashboard extends React.Component {
  state = {
    data: {},
    tracks: {},
    type: 'today'
  };

  getDashBoardData = (filterValue = 'today') => {
    DashboardMainGet({type: filterValue})
      .then(data => {
        this.setState({tracks: data['tracks'].reverse(), type: filterValue})
      })
  };

  componentDidMount() {
    this.getDashBoardData()
  }

  render() {
    const {tracks, type} = this.state;

    return (
      <div id="main-content">
        <div className="container-fluid">
          <div className="block-header">
            <div className="row clearfix">
              <div className="col-sm-4 col-12">
                <h3 className="main-heading">Monitoring Dashboard</h3>
              </div>
              <div className="col-sm-8 col-12">
                <ul className="nav justify-content-end top-submenu">
                  <li className={'nav-item ' + (type === 'today' && 'active')}>
                    <a onClick={() => this.getDashBoardData('today')} className="nav-link ">Today</a>
                  </li>
                  <li className={'nav-item ' + (type === 'week' && 'active')}>
                    <a onClick={() => this.getDashBoardData('week')} className="nav-link">1 Week</a>
                  </li>
                  <li className={'nav-item ' + (type === 'month' && 'active')}>
                    <a onClick={() => this.getDashBoardData('month')} className="nav-link">1 Month</a>
                  </li>
                  <li className={'nav-item ' + (type === 'month3' && 'active')}>
                    <a onClick={() => this.getDashBoardData('month3')} className="nav-link">3 Month</a>
                  </li>
                  <li className={'nav-item ' + (type === 'month6' && 'active')}>
                    <a onClick={() => this.getDashBoardData('month6')} className="nav-link">6 Month</a>
                  </li>
                  <li className={'nav-item ' + (type === 'year' && 'active')}>
                    <a onClick={() => this.getDashBoardData('year')} className="nav-link">1 Year</a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="row clearfix">
              <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                <div className="card">
                  <div className="header">
                    <h4>AB tracks</h4>
                  </div>
                  <div className="body">
                    <div className="row">
                      <div className="col-sm-8 col-5">
                        {Object.keys(tracks).length &&
                        <LineChart width={250} height={150} data={tracks} margin={{left: 5}}>
                          <XAxis dataKey="name"/>
                          <YAxis/>

                          <Tooltip/>
                          <Line type="monotone" dataKey="quotes" stroke="#058d28"/>
                          <Line type="monotone" dataKey="workorders" stroke="#8884d8"/>
                          <Line type="monotone" dataKey="hotsheets" stroke="#ff0000"/>
                        </LineChart>}
                      </div>
                      <div className="col-sm-4 col-7 padding-0">
                        <ul className="crm-graph-list track-list">
                          <li>
                            <span className="quote-point-color">Quotes</span>
                            <span>{tracks.quotes}</span>
                          </li>
                          <li>
                            <span className="wrk-odr-point-color">Work Order</span>
                            <span
                              className="work-odr-graph-color">{tracks.workorders}</span>
                          </li>
                          <li>
                            <span className="hotsheet-point-color">Hot Sheet</span>
                            <span className="hotsheet-graph-color">{tracks.hotsheets}</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                <div className="card">
                  <div className="header">
                    <h4>AB CRM</h4>
                  </div>
                  <div className="body">
                    <div className="pull-left crm-graph">
                      <h5 className="coming-soon-heading m-t-20">
                        Coming <br/> Soon
                      </h5>
                    </div>
                    <ul className="crm-graph-list">
                      <li>
                        <span>Quote</span>
                        <span>26</span>
                      </li>
                      <li>
                        <span>Sales Calls</span>
                        <span>12</span>
                      </li>
                      <li>
                        <span>Requests</span>
                        <span>19</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                <div className="card">
                  <div className="header">
                    <h4>AB Marketing</h4>
                  </div>
                  <div className="body marketing-main">
                    <div className="row">
                      <div className="col-sm-6 col-6">
                        <div className="float-left m-r-15 p-l-25 m-t-5 marketing-content">
                          <h6 className="mb-0 mt-0 number-style"> 6</h6>
                          <small className="heading-small ml-2">
                            Email Canpains
                          </small>
                        </div>
                      </div>
                      <div className="col-sm-6 col-6">
                        <div className="float-left m-r-15 p-l-25 m-t-5 marketing-content ">
                          <h6 className="mb-0 mt-0 number-style"> 56</h6>
                          <small className="heading-small ml-2">Leads</small>
                        </div>
                      </div>
                    </div>
                    <h5 className="heading-small m-t-30 m-b-30 text-center theme-color">
                      Website Traffic
                    </h5>
                    <div className="row marketing-div">
                      <div className="col-md-6 col-6">
                        <i className="fa fa-google-plus"/>
                        <span>Top Reffering Sites</span>
                      </div>
                      <div className="col-md-6 col-6">
                        <i className="fa fa-linkedin"/>
                        <span>Top Reffering Searches</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                <div className="card">
                  <div className="header">
                    <h4>AB Financial</h4>
                  </div>
                  <div className="body financial-div">
                    <ul className="right_chat list-unstyled mb-0">
                      <li>
                        <div className="media">
                          <div className="media-body">
                            <span className="heading-small">
                              21 hours ago
                              </span>
                            <span className="heading-small theme-color pull-right">
                              $123466.44
                              </span>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="media">
                          <div className="media-body">
                            <span className="heading-small">3 hours ago</span>
                            <span className="heading-small theme-color pull-right">
                              $123466.44
                              </span>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="media mb-0">
                          <div className="media-body">
                            <span className="heading-small">3 hours ago</span>
                            <span className="heading-small theme-color pull-right">
                              $123466.44
                              </span>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                <div className="card">
                  <div className="header">
                    <h4>AB Dispatch</h4>
                  </div>
                  <div className="body">
                    {/*<ul className="right_chat list-unstyled mb-0 dispatch-div">*/}
                    {/*<li>*/}
                    {/*<div className="media">*/}
                    {/*<img className="media-object" src={Images.user_image} alt="" />*/}
                    {/*<div className="media-body row">*/}
                    {/*<div className="col-sm-6">*/}
                    {/*<span className="message">Call In</span>*/}
                    {/*<span className="heading-small theme-color">*/}
                    {/*1234568*/}
                    {/*</span>*/}
                    {/*</div>*/}
                    {/*<div className="col-sm-6">*/}
                    {/*<span className="message">Recurring</span>*/}
                    {/*<span className="heading-small theme-color">*/}
                    {/*Lorem Ipsum*/}
                    {/*</span>*/}
                    {/*</div>*/}
                    {/*</div>*/}
                    {/*</div>*/}
                    {/*</li>*/}
                    {/*</ul>*/}
                    <h5 className="coming-soon-heading m-auto-LR m-t-20 ">
                      Coming <br/> Soon
                    </h5>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                <div className="card">
                  <div className="header">
                    <h4>AB Operation Analytics</h4>
                  </div>
                  <div className="body">
                    <div id="m_area_chart"/>
                    <h5 className="coming-soon-heading m-auto-LR m-t-20 ">
                      Coming <br/> Soon
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Dashboard.jsx